import { Link, matchPath } from 'react-router-dom';
import { allPages, IPage, Variant } from '../models/Page';
import { buildVariantHref } from './Variant';

export function getSelectedPageIndex(currentPath: string) {
    let index = 0;
    allPages.forEach((page) => {
        const doesMatch = matchPath(page.href, currentPath);
        if (doesMatch) {
            index = allPages.indexOf(page);
        } else if (page.children) {
            page.children.forEach((childPage) => {
                const doesMatch = matchPath(childPage.href, currentPath);
                if (doesMatch) {
                    index = allPages.indexOf(page);
                }
            });
        }
    });

    return index;
}

function breadcrumbLinkForPage(page: IPage, variant: Variant | null) {
    return (
        <Link key={page.title} to={buildVariantHref(page.href, variant)} style={{ textDecoration: 'none' }}>
            {page.title}
        </Link>
    );
}

export function breadcrumbsForPage(index: number, currentPath: string, variant: Variant | null) {
    const selectedPage = allPages[index];
    const home = allPages[0];
    const breadcrumbs = [
        breadcrumbLinkForPage(home, variant)
    ];

    if (selectedPage.href !== home.href) {
        breadcrumbs.push(breadcrumbLinkForPage(selectedPage, variant));
    }

    if (selectedPage.href !== currentPath && selectedPage.children) {
        selectedPage.children.forEach((childPage) => {
            if (childPage.href === currentPath) {
                breadcrumbs.push(breadcrumbLinkForPage(childPage, variant));
            }
        });
    }

    return breadcrumbs;
}
